import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { InitGuard } from '../../guards/init.guard';

import { AuthService } from '../../services/auth.service';
import { AccountService } from '../../services/account.service';

@Component({
    selector: 'app-init',
    templateUrl: './init.component.html',
    styleUrls: ['./init.component.css']
})
export class InitComponent implements OnInit {

    name: string = '';
    errMsg: string;

    constructor(private router: Router,
        private initGuard: InitGuard,
        private authService: AuthService,
        private accountService: AccountService) { }

    ngOnInit() {
        if (this.initGuard.checkAccount()) // if logged in redirect to home
            this.router.navigate(['/']);
    }

    createAccount() {
        this.accountService.createAccount(this.name).subscribe(
            (res) => {
                this.authService.saveAccount(res);
                this.router.navigate(['/']);
            },
            (err) => console.error(err)
        );
    }
}
